module.exports = __webpack_public_path__ + "static/NewYorkSm-b8efd42cc74f576d240b97de62e1b725.jpg";